import { ClubHttpHelper, NO_DATA_MESSAGE } from '../../../utils/HttpHelper';
import Constants from '../../../utils/Constants';

export const INITIAL_STATE = {
  isArrayLoading: false,
  isArrayLoaded: false,
  facilityId: Constants.DEFAULT_ID,
  arrayData: [],
  options: [],
  message: ''
};

const getFacilityLscData = (facilityId, state, setState) => {
  if (state.isArrayLoading !== true && facilityId > 0) {
    const newState = {
      ...state,
      facilityId,
      isArrayLoading: true,
      isArrayLoaded: false,
      message: 'Loading...'
    };
    setState(newState);

    const facilityIdForUrl = facilityId ? encodeURIComponent(facilityId) : 'NaN';
    const url = `/Facility/Lsc/${facilityIdForUrl}`;
    ClubHttpHelper(url, 'GET')
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          const options = arrayData.map((facilityLsc) => {
            return { id: facilityLsc.orgUnitId, name: facilityLsc.orgUnitName };
          });
          options.unshift({ id: Constants.DEFAULT_ID, name: '--' });

          setState({
            ...newState,
            isArrayLoading: false,
            isArrayLoaded: true,
            arrayData,
            options,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoading: false,
          isArrayLoaded: false,
          message: message
        });
      });
  }
};

const FacilityLscData = { INITIAL_STATE, getFacilityLscData };

export default FacilityLscData;
